import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Paginator } from '@app/classes/paginator';
import { DepartmentsTable } from '@app/modules/employees/services';
import { EmployeeModuleMenuService } from '@app/modules/employees/services/employee-module-menu.service';
import { AuthService } from '@app/services/auth.service';
import { NotifyService } from '@app/services/notify.service';
import { IndexView } from '@common/views';
import { BaseForm } from '@forms/base.form';
import { Department } from '@models/company/department.model';

@Component({
    templateUrl: './department-index.template.html',
})
export class DepartmentIndexView extends IndexView {
    isLoading = true;
    isCreateDepartmentDialogOpen = false;

    paginator: Paginator;
    departments: Department[] = [];

    constructor(
        private route: ActivatedRoute,
        private auth: AuthService,
        private notify: NotifyService,
        private router: Router,
        public table: DepartmentsTable,
        public employeeModuleMenuService: EmployeeModuleMenuService
    ) {
        super();

        this.paginator = new Paginator(Department.param('company', this.auth.company?.id), {
            shouldAutoLoadData: true,
        });
        this.paginator.onLoading((isLoading) => (this.isLoading = isLoading));
        this.table.reload();
    }

    openDialog(): void {
        this.isCreateDepartmentDialogOpen = true;
    }

    closeDialog(): void {
        this.isCreateDepartmentDialogOpen = false;
    }

    onCreate(department: Department, form: BaseForm): void {
        form.submit();

        if (!form.valid) {
            return;
        }

        this.isLoading = true;
        department
            .param('company', this.auth.company?.id)
            .save()
            .then((res) => {
                form.reset();
                this.router.navigate([res.id], { relativeTo: this.route });
                this.isLoading = false;
            })
            .catch((err) => {
                this.notify.error(err.message || 'Could not save department');
                this.isLoading = false;
            });
    }
}
